import React from 'react';
import { Row, TableData } from 'components/common/tableElements';

const CustomOrderSearchResult = ({ order, clickAction, even }) => {
  return (
    <Row onClick={(event) => clickAction(event, order)} hoverPointer={true} even={even}>
      <TableData>{order.email}</TableData>
      <TableData>{order.applicationPlatform}</TableData>
    </Row>
  );
};

export default CustomOrderSearchResult;
